// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — options-toggle.classic.js, новая — options-toggle.cp.js
import { isCp } from 'libs/design';
import * as classic from './options-toggle.classic';
import * as cp from './options-toggle.cp';

export const OptionsToggle = isCp ? cp.OptionsToggle : classic.OptionsToggle;
